import { Button, Switch, IconButton } from '@material-ui/core';
import React from 'react';
import { trackPromise } from "react-promise-tracker";
import VisibilityIcon from '@material-ui/icons/Visibility';
import defaultImg from '../../../../assets/img/bioimg.png'

export const TableContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {hasEdit ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}

export const TableContentViewV2 = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {hasEdit ? (
                    <td style={{ cursor: "pointer" }}>
                        <IconButton onClick={() => handleClick(da)} title="View">
                            <VisibilityIcon />
                        </IconButton>
                    </td>
                ) : null}
            </tr>
        );
    })
}

export const TableContentDelete = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit || hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-trash-alt"></i></td> : null}
            </tr>
        );
    })
}

export const ReportTableContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "selectedRange" ? (<td key={index}>{da[row] + " "}</td>) :
                <td style={{ textAlign: "right" }} key={index}>{da[row] + " "}</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}


export const DailyCollectionReportContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (da[row] === undefined ? <td key={index} style={{ textAlign: "center" }}>-</td> :
                index > 6 ? <td key={index} style={{ textAlign: (row === "lossGain" ? "center" : "right") }}>{da[row] + " "}</td> :
                    <td key={index} style={{ textAlign: "center" }}>{da[row] + " "}</td>)
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}

export const SoSTableContent = ({ data, contentRowNames, handleClick, hasEdit, actiontype }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                <td key={index}>{da[row] + " "}</td>
            )
        )
    })
    if (actiontype == "SOS") {
        return data.map((da, i) => {
            return (
                <tr key={i}>
                    {content(da)}
                    {(hasEdit || hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="fa fa-play-circle fa-lg"></i></td> : null}
                </tr>
            );
        })

    } else if (actiontype == "EOS") {
        return data.map((da, i) => {
            return (
                <tr key={i}>
                    {content(da)}
                    {(hasEdit || hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="fa fa-pause fa-lg"></i></td> : null}
                </tr>
            );
        })
    } else {
        return data.map((da, i) => {
            return (
                <tr key={i}>
                    {content(da)}
                    {(hasEdit || hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
                </tr>
            );
        })
    }

}

export const CustomerBiometricsTableContent = ({ data, contentRowNames, handleRemoveClick, hasEdit, hasDefault, hasView, handleViewClick, hasDelete, handleDeleteClick, handleIsDefaultChange }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                <td key={index}>{da[row] + " "}</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleRemoveClick(da)} style={{ cursor: "pointer" }}><img src={da.customerBiometricData} width="100" height="100" /></td> : null}
                {(hasDelete === undefined) ? <td onClick={() => handleDeleteClick(da)} style={{ cursor: "pointer" }}><i className="fas fa-trash-alt"></i></td> : null}
                {(hasView === undefined) ? <td onClick={() => handleViewClick(da)} style={{ cursor: "pointer" }}><i className="fas fa-eye"></i></td> : null}
                {(hasDefault === undefined) ? <td><Switch color="primary" onChange={() => trackPromise(handleIsDefaultChange(da.customerBiometricID))} checked={da.isDefault} /></td> : null}

            </tr>
        );
    })
}


export const TableContentUserList = ({ data, contentRowNames, handleClick, hasEdit, hasReset, handleReset }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                row === "isLocked" ? (da[row] === true ? <td key={index}>Locked</td> : <td key={index}>Unlocked</td>) :
                    <td key={index}>{da[row] + " "}</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
                {(hasReset === undefined) ? <td onClick={() => handleReset(da)} style={{ cursor: "pointer" }}><i className="fa fa-refresh"></i></td> : null}
            </tr>
        );
    })
}

export const EmployeeBiometricsTableContent = ({ data, contentRowNames, handleRemoveClick, hasEdit, hasView, hasDefault, handleViewClick, hasDelete, handleDeleteClick, handleIsDefaultChange }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                <td key={index}>{da[row] + " "}</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleRemoveClick(da)} style={{ cursor: "pointer" }}><img src={da.employeeBiometricData} width="100" height="100" /></td> : null}
                {(hasDelete === undefined) ? <td onClick={() => handleDeleteClick(da)} style={{ cursor: "pointer" }}><i className="fas fa-trash-alt"></i></td> : null}
                {(hasView === undefined) ? <td onClick={() => handleViewClick(da)} style={{ cursor: "pointer" }}><i className="fas fa-eye"></i></td> : null}
                {(hasDefault === undefined) ? <td><Switch color="primary" onChange={() => trackPromise(handleIsDefaultChange(da.employeeBiometricID))} checked={da.isDefault} /></td> : null}
            </tr>
        );
    })
}

export const WeighReportContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            ((da[row] === undefined || da[row] === null) ? <td key={index} style={{ textAlign: "center" }}>-</td> : (row === "firstName" ?
                <td key={index}>
                    <div className="row">
                        <div className="col">
                            {da[row] + ""}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div>
                                {da.convertedEmployeeBiometricData !== null ? <img src={da.convertedEmployeeBiometricData} width="75" height="75" /> : null}
                            </div>
                        </div>
                    </div>
                </td> : (row === "profit" ? <td key={index} align={"center"}>
                    <span className={da[row].includes("Loss") ? "badge badge-danger" : "badge badge-primary"}>{da[row]}</span>
                </td>
                    : <td key={index} align={"center"}>{da[row] + " "}</td>)))
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}

export const VarianceContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            ((da[row] === undefined || da[row] === null) ? <td key={index} style={{ textAlign: "center" }}>-</td> : (row === "netVarience" || row === "grossVariance") ?
                <td key={index} align={"center"}>
                    <span className={da[row] < 0 ? "badge badge-primary" : "badge badge-danger"}>{Math.abs(da[row])}</span>
                </td>
                : <td key={index} align={"center"} style={{ fontSize: "12px" }}>{da[row] + " "}</td>)
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i class="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}

export const TableContentCustomer = ({ data, contentRowNames, handleClick, handleClickView, hasEdit, hasView, handleClick2, hasEdit2 }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                <td key={index}>{da[row] + " "}</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasView || hasView === undefined) ? <td onClick={() => handleClickView(da)} style={{ cursor: "pointer" }}><i className="fas fa-eye"></i></td> : null}
                {(hasEdit || hasEdit === undefined) ? <td >
                    <Button><i className="fa fa-picture-o" onClick={() => handleClick(da)} style={{ cursor: "pointer" }}></i></Button>
                    <Button> <i className="fas fa-edit" onClick={() => handleClick2(da)} style={{ cursor: "pointer" }}></i></Button></td> : null}
            </tr>
        );
    })
}

export const TableEmployeeTaskDetails = ({ data, contentRowNames }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isSOSEnabled" ?
                (da[row] === 1 ? <td key={index}>Active</td> : <td key={index}>Inactive</td>)
                :
                (row === "progress" ?
                    <td key={index}>
                        <div className="progress" style={{ height: "17px" }}>
                            <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                                aria-valuenow={da[row]} aria-valuemin="0" aria-valuemax="100" style={{ width: da[row] + "%" }}>{da[row] + "%"}</div>
                        </div>
                    </td> :
                    (row === "firstName" ?
                        <td key={index}>
                            <div className="row">
                                <div className="col">
                                    {da[row] + ""}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div>
                                        {da.convertedEmployeeBiometricData !== null ? <img src={da.convertedEmployeeBiometricData} width="75" height="75" /> : null}
                                    </div>
                                </div>
                            </div>
                        </td> :
                        <td key={index}>{da[row] + " "}</td>))
            )
        )
    });

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}
export const TableContentPurchase = ({ data, contentRowNames, handleClick, purchaseValue }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "measuringUnit" ? (da[row] === 1 ? <td key={index}>Kg</td> : <td key={index}>Unit</td>) :
                    (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>))
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                <td>
                    <Button disabled={false} onClick={() => handleClick(da)} style={{ cursor: "pointer", outline: 'none' }} >
                        <i className="far fa-trash-alt"></i>
                    </Button>
                </td>
            </tr>
        );
    })
}

export const TableContentForStatusType = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {

        return (
            (row === "statusTypeID" ? (da.statusTypeID === 1 ? <td key={index}>New</td> : da.statusTypeID === 2 ?
                <td key={index}>Review</td> : da.statusTypeID === 3 ? <td key={index}>Ready To Collection</td> : da.statusTypeID === 4 ?
                    <td key={index}>Order Reject</td> : da.statusTypeID === 5 ? <td key={index}>Complete</td> : da.statusTypeID === 7 ? <td key={index}>Item Rejected</td> :
                        <td key={index}>ReadyToShip</td>) :
                (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit || hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : <td></td>}
            </tr>
        );
    })
}

export const EstateComparisonTableContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>-</td> : <td key={index} style={{ textAlign: "right" }}>{da[row]}</td>)
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit || hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}

export const DivisionReportTableContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (da[row] === undefined ? (row === "recievingFactory" ? <td key={index} style={{ textAlign: "center" }}>-</td> : (row === "factoryNoOfBags" || row === "fieldNoOfBags") ?
                <td key={index} style={{ textAlign: "right" }}>0</td> : <td key={index} style={{ textAlign: "right" }}>0.00</td>) :
                ((row === "collectionPointName" || row === "fieldName") ? <td style={{ textAlign: "left" }} key={index}>{da[row]}</td> :
                    (row === "recievingFactory" ? <td style={{ textAlign: "center" }} key={index}>{da[row]}</td> : <td style={{ textAlign: "right" }} key={index}>{da[row]}</td>))
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit || hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}

export const DailyCropRecoReportContent = ({ data, contentRowNames, handleClick, hasEdit }) => {
    if (data === undefined) return null;

    const formatValue = (value) => {
        if (typeof value === 'number') {
            return value.toFixed(2);
        }
        return value;
    };

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (da[row] === undefined ?
                ((row === "tagNumber" || row === "ftagNumber") ?
                    <td key={index} style={{ textAlign: "center", backgroundColor: "#EF5350", color: "#ECEFF1" }}>-</td> :
                    <td key={index} style={{ textAlign: "center" }}>-</td>) :
                ((row === "tagNumber" || row === "ftagNumber") ?
                    <td key={index} style={{ textAlign: "center", backgroundColor: "#4CAF50", color: "#ECEFF1" }}>
                        {da[row] + " "}</td> :
                    (index > 4 ?
                        <td key={index} style={{ textAlign: "right" }}>{formatValue(da[row]) + " "}</td> :
                        <td key={index} style={{ textAlign: "center" }}>{formatValue(da[row]) + " "}</td>)))
        );
    });

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ?
                    <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}>
                        <i className="far fa-edit"></i>
                    </td> :
                    null}
            </tr>
        );
    });
};


export const EmployeeCropTableContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "date" ? (<td key={index}>{da[row] + " "}</td>) :
                <td style={{ textAlign: "right" }} key={index}>{da[row] + " "}</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}

export const TableContentPurchaseView = ({ data, contentRowNames, handleClick, purchaseValue }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "measuringUnit" ? (da[row] === 1 ? <td key={index}>Kg</td> : <td key={index}>Unit</td>) :
                    (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>))
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                <td>
                    <Button disabled={(da.isButtonEnabled === 0 || da.isButtonEnabled === undefined) ? true : false} onClick={() => handleClick(da)} style={{ cursor: "pointer", outline: 'none' }} >
                        <i className="far fa-trash-alt"></i>
                    </Button>
                </td>
            </tr>
        );
    })
}

export const TableContentForViewWeighmnet = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {

        return (
            (row === "statusTypeID" ? (da.statusTypeID === 1 ? <td key={index}>New</td> : da.statusTypeID === 2 ?
                <td key={index}>Review</td> : da.statusTypeID === 3 ? <td key={index}>Ready To Collection</td> : da.statusTypeID === 4 ?
                    <td key={index}>Order Reject</td> : da.statusTypeID === 5 ? <td key={index}>Complete</td> : da.statusTypeID === 7 ? <td key={index}>Item Rejected</td> :
                        <td key={index}>ReadyToShip</td>) :
                (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit || hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}

export const TableContentWithoutEdit = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForEmployeeSessionImageReport = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            row === "isActive" ? (
                <td key={index}>{da[row] === true ? "Active" : "Inactive"}</td>
            ) : row === "employeeCode" || row === "firstName" ? (
                <td key={index}>{da[row] + ""}</td>
            ) : (
                <td key={index} style={{ textAlign: "center" }}>
                    <img
                        src={da[row] || defaultImg}
                        width="75"
                        height="75"
                        alt="Employee"
                    />
                </td>
            )
        );
    });


    return data.map((da, i) => (
        <tr key={i}>
            {content(da)}
        </tr>
    ));
};

export const TableContentForMasterCardLeafCollection = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) :
                    ((row === "totalAmount" || row === "netAmount") ? <td key={index} style={{ textAlign: "right" }}>{da[row] + " "}</td> : <td key={index}>{da[row] + " "}</td>)
                )
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForRouteWiseCropDetails = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "netAmount" ? <td key={index} style={{ textAlign: "right" }}><b>{da[row]}</b></td> :
                da[row] === undefined ? <td key={index}>0.00</td> : <td style={{ textAlign: index > 0 ? "right" : "left" }} key={index}>{da[row]}</td>)
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForMasterCardTagReport = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "total" ? <td key={index} style={{ textAlign: "right" }}><b>{da[row]}</b></td> :
                ((da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>0</td>
                    : row === "collectionPointName" ? <td key={index}>{da[row]}</td>
                        : <td key={index} style={{ textAlign: "right" }}>{da[row]}</td>))
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForManualLeafReport = ({ data, contentRowNames }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "regNo" || row === "name") ? <td key={index} >{da[row]}</td> :
                (da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>{(0).toFixed(2)}</td> :
                    <td key={index} style={{ textAlign: "right" }}>{da[row].toFixed(2)}</td>
                )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}
export const TableContentForLeafSupplierDetails = ({ data, contentRowNames }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            ((row === "netAmount" && row[da] !== undefined) ? <td key={index} ><b>{da[row].toFixed(2)}</b></td> :
                ((da[row] === undefined ? <td key={index}>0</td> : <td key={index}>{da[row]}</td>))
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForRouteSummary = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>{(0).toFixed(2)}</td> : (row === "regNo" ? <td key={index}>{da[row]}</td> :
                <td key={index} style={{ textAlign: "right" }}>{da[row].toFixed(2)}</td>)
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForRouteMangerPrintOption = ({ data, contentRowNames }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (da[row] === undefined && (row === "fieldTagNumber" || row === "factoryTagNumber") ?
                <td key={index} style={{ textAlign: "right" }}>-</td> :
                (da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>
                    {(row === "isOperationCardVerified" && da[row] === undefined) ? "" : 0.00}
                </td>
                    : row === "isOperationCardVerified" ?
                        <td key={index} style={{ textAlign: "Left" }}>{da[row] === true ? "Master Card" : "Customer Card"}</td> :
                        <td key={index} style={{ textAlign: (row === "regNo" ? "left" : "right") }}>{da[row]}</td>
                )
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const DailyleafCollectionRouteWiseTableContent = ({ data, contentRowNames }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            // da[row] === undefined ? <td key={index} style={{textAlign: "right"}}>{(0).toFixed(2)}</td> : 
            (row === "name" || row === "registrationNumber" ? <td key={index}>{da[row]}</td> :
                da[row] !== undefined ? <td key={index} style={{ textAlign: "right" }}>{da[row].toFixed(2)}</td> :
                    <td key={index} style={{ textAlign: "right" }}>{(0).toFixed(2)}</td>)
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentWithoutEditDateFromat = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            <td key={index}>{da[row] + ""}</td>
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForRouteSummaryReport = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {

        if (row == "loexx") {

            return (
                da[row] === undefined ? <td key={index} style={{ background: "yellow", textAlign: "right" }}>0</td> :
                    <td key={index} style={{ background: "yellow", textAlign: "right" }}> {da[row]}</td>
            )

        } else if (row == "grossBalance") {

            return (
                da[row] === undefined ? <td key={index} style={{ background: "yellow", textAlign: "right" }}>0</td> :
                    <td key={index} style={{ background: "yellow", textAlign: "right" }}> {da[row]}</td>
            )

        }
        else {
            return (

                da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>0</td> :
                    row !== "collectionPointName" ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td> :
                        <td key={index} style={{ textAlign: "left" }}><b>{da[row]}</b></td>
            )
        }

    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForRouteSummaryRTFReport = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => (
        da[row] === undefined
            ? <td key={index} style={{ textAlign: row === "collectionPointName" ? "left" : "right" }}>{row === "collectionPointName" ? <b>0</b> : "0"}</td>
            : <td key={index} style={{ textAlign: row === "collectionPointName" ? "left" : "right" }}>{row === "collectionPointName" ? <b>{da[row]}</b> : da[row]}</td>
    ));

    return data.map((da, i) => (
        <tr key={i}>
            {content(da)}
        </tr>
    ));
};

export const TableContentForLeafCollectionSummary = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>0.00</td> :
                row !== "date" ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td> :
                    <td key={index} style={{ textAlign: "left" }}>{da[row]}</td>
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const BlockWeighmentTableContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "registrationNumber" ? (<td key={index}>{da[row] + " "}</td>) :
                row === "numberOfUnits" ? <td key={index} style={{ textAlign: "center" }}>{da[row] + " "}</td> :
                    isNaN(da[row]) ? <td style={{ textAlign: "right" }} key={index}>{da[row] + " "}</td>
                        : <td style={{ textAlign: "right" }} key={index}>{parseFloat(da[row]).toFixed(2)}</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}

export const TableContentForCustomerLeafWiseCollection = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "numberOfUnits" || row === "grossTotalAmount" ||
                row === "netAmount" || row === "totalDeduction" || row === "returnValue") ?
                <td key={index} style={{ textAlign: "right" }}>{da[row]}</td> : <td key={index}>{da[row]}</td>
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForLeafCollectionVarianceReport = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>0</td> :
                row.includes("_Kg") ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td> :
                    <td key={index} style={{ textAlign: "left" }}>{da[row]}</td>
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForSumLeafCollectionVarianceReport = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "fieldCollectionPointName") ? <td key={index} style={{ textAlign: "left" }}>{da[row]}</td> :
                ((row === "fieldNumberOfUnits" || row === "glx") ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td>
                    : da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>{(0).toFixed(2)}</td> :
                        <td key={index} style={{ textAlign: "right" }}>{da[row].toFixed(2)}</td>)
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TotalCropReportTable = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "weightReadTime" || row === "collectionPointName") ? <td key={index}>{da[row]}</td>
                : da[row] === "-" || da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td>
                    : <td key={index} style={{ textAlign: "right" }}>{da[row].toFixed(2)}</td>
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForLeafCollectionRouteWiseReport = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>0.00</td> :
                (row.includes("_Kg") || row === "glx") ? <td key={index} style={{ textAlign: "right" }}>{da[row].toFixed(2)}</td> :
                    <td key={index} style={{ textAlign: "left" }}>{da[row]}</td>
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForFactoryRouteWeighReport = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>{(0).toFixed(2)}</td> :
                (row.includes("_Kg") ? <td key={index} style={{ textAlign: "right" }}>{da[row].toFixed(2)}</td> :
                    <td key={index} style={{ textAlign: (row === "fieldNumberOfUnits" ? "right" : "left") }}>{da[row]}</td>))
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForRouteWiseCollectionTypeTotal = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>0.00</td> :
                <td key={index} style={{ textAlign: ((row === "date" || row === "collectionPointName") ? "left" : "right") }}>{da[row]}</td>
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}


export const TableContentForCustomerLeafCollectionReport = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            ((row !== "registrationNumber" && !isNaN(da[row])) ? <td key={index} style={{ textAlign: "right" }}>
                {row === "numberOfUnits" ? (da[row] + " ") : da[row].toFixed(2)}</td>
                : <td key={index}>{da[row] + " "}</td>)
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}


export const TableContentForCheckrollWeighReport = ({ data, contentRowNames, handleClick, hasEdit, deductions }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            ((da[row] === undefined || da[row] === null) ? <td key={index} style={{ textAlign: "center" }}>-</td> :
                (row === "profit" ? <td key={index} align={"center"}>
                    <span className={da[row].includes("Loss") ? "badge badge-danger" : "badge badge-primary"}>{da[row]}</span>
                </td>
                    : <td key={index} align={(index > 4) ? "right" : (index === 0 ? "lrft" : "center")}>
                        {(index > 4 && index <= (4 + deductions.length + 1)) ? da[row] + " " : da[row] + " "}</td>
                ))
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}

export const TableContenForLoftSummaryReport = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (
                da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>{(0).toFixed(2)}</td> :
                    (row === "collectionPointName" ? <td key={index}>{da[row]}</td>
                        : (row === "bagCount" ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td> :
                            <td key={index} style={{ textAlign: "right" }}>{da[row].toFixed(2)}</td>))
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContenForLossExcessReport = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (
                da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>{0.00}</td> :
                    (row === "pluckingCheckrollWeight" || row === "factoryTotal" || row === "lossGain") ?
                        <td key={index} style={{ textAlign: "right" }}>
                            {row === "lossGain" ?
                                <h5><span class={da[row] > 0 ? "badge badge-primary" : "badge badge-danger"}>
                                    {da[row].toFixed(2)}
                                </span></h5>
                                : da[row].toFixed(2)}
                        </td> :
                        <td key={index} style={{ textAlign: "left" }}>{da[row]}</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForDairyCollectionDetailedReport = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>{0.00}</td> :
                (row === "fat" || row === "density" || row === "grossAmount" ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td> :
                    <td key={index} style={{ textAlign: "left" }}>{da[row]}</td>)
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}
export const TableContentCollectionSummaryReport = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (
                da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>0.00</td> :
                    (row === "collectionPointName" ? <td key={index} style={{ textAlign: "left" }}>{da[row]}</td> :
                        <td key={index} style={{ textAlign: "right" }}>{da[row].toFixed(2)}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}
export const TableContentSupplierDairySummaryReport = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (
                da[row] === undefined ? <td key={index} style={{ textAlign: "left" }}>0.00</td> :
                    (row === "grossAmount" ? <td key={index} style={{ textAlign: "right" }}>{da[row].toFixed(2)}</td> :
                        <td key={index} style={{ textAlign: "left" }}>{da[row]}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const ReportCeneteredTableContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "selectedRange" ? (<td key={index}>{da[row] + " "}</td>) :
                <td key={index}>{da[row] + " "}</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}



export const IgnoreSessionTableContent = ({ data, contentRowNames, handleReject, handleApprove, hasEdit, status }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {((hasEdit || hasEdit === undefined) && status == 1) ? <td onClick={() => handleReject(da)} style={{ cursor: "pointer" }}><i className="fas fa-times"></i></td> : null}
                {((hasEdit || hasEdit === undefined) && status == 1) ? <td onClick={() => handleApprove(da)} style={{ cursor: "pointer" }}><i className="fas fa-check"></i></td> : null}
            </tr>
        );
    })
}


export const TableContentForLeafCollectionDetailsReport = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>0.00</td> :
                (row.includes("_Kg") || row === "glx" || row === "ag") ? <td key={index} style={{ textAlign: "right" }}>{da[row].toFixed(2)}</td> :
                    <td key={index} style={{ textAlign: "left" }}>{da[row]}</td>
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}
export const DivisionDetailReportTableContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (da[row] === undefined ? <td key={index} style={{ textAlign: "center" }}>-</td> :
                ((row !== "collectionPointName" || row !== "fieldName") ? <td style={{ textAlign: "right" }} key={index}>{da[row]}</td> :
                    (row === "collectionPointName" || row === "fieldName" ? <td style={{ textAlign: "left" }} key={index}>{da[row]}</td> : <td style={{ textAlign: "right" }} key={index}>{da[row]}</td>))
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit || hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}
export const RouteDeductionDetailsReportTable = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "deductionPercentage") ? <td key={index} style={{ textAlign: "right" }}>{da[row].toFixed(1)}</td>
                : da[row] === "-" || da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td>
                    : row === "collectionPointName" ? <td key={index} style={{ textAlign: "left" }}>{da[row]}</td>
                        : <td key={index} style={{ textAlign: "right" }}>{da[row]}</td>
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}


export const TableContentForLeafCollectionRouteSummaryReport = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>0</td> :
                row !== "collectionPointName" ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td> :
                    <td key={index} style={{ textAlign: "left" }}>{da[row]}</td>
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}


export const TableContentLeafCollectionOverviewContent = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null


    const content = (da) => contentRowNames.map((row, index) => {
        if (index === 2 || index === 3 || index === 4) {

            TableContentLeafCollectionOverview(data, contentRowNames, handleClick)
        }
        else {

            return (
                (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                    (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
                )
            )
        }
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}


export const TableContentLeafCollectionOverview = ({ data, contentRowNames, handleClick }) => {



    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {

        if (index !== 0 || index !== 1)
            return (
                (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                    (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
                )
            )
    })


    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}


export const LoftAmendmentTableContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "collectionPointName" ? (<td key={index}>{da[row] + " "}</td>) :
                <td key={index}>{da[row] + " "}</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}

export const WeighPointWiseDeductionReportTableContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "registrationNumber" ? (<td key={index}>{da[row] + " "}</td>) :
                row === "numberOfUnits" ? <td key={index} style={{ textAlign: "center" }}>{da[row] + " "}</td> :
                    da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>0</td> :
                        isNaN(da[row]) ? <td style={{ textAlign: "left" }} key={index}>{da[row] + " "}</td>
                            : <td style={{ textAlign: "right" }} key={index}>{parseFloat(da[row]).toFixed(2)}</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}
export const DayWiseEmployeeCheckRollTable = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "createdDate") ? <td key={index} style={{ textAlign: "left" }}>{da[row]}</td>
                : da[row] === "-" || da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td>
                    : <td key={index} style={{ textAlign: "right" }}>{da[row]}</td>
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}



export const SessionIgnoreReportTableContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "registrationNumber" ? (<td key={index}>{da[row] + " "}</td>) :
                row === "numberOfUnits" ? <td key={index} style={{ textAlign: "center" }}>{da[row] + " "}</td> :
                    isNaN(da[row]) ? <td style={{ textAlign: "left" }} key={index}>{da[row] + " "}</td>
                        : <td style={{ textAlign: "left" }} key={index}>-</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}

export const EmployeeWiseCheckRollMonthlySummaryTable = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "epfNo" || row === "registrationNumber" || row === "firstName") ? <td key={index} style={{ textAlign: "left" }}>{da[row]}</td>
                : da[row] === "-" || da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td>
                    : <td key={index} style={{ textAlign: "right" }}>{da[row]}</td>
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}


export const DailyTaskDetailReportTableContent = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "fieldName") ? (da[row] === null ? <td key={index}>-</td> : <td key={index}>{da[row]}</td>) :
                    (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const BlockPluckingReportTableContent = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "fieldName") ? (da[row] === null ? <td key={index}>-</td> : <td key={index}>{da[row]}</td>) :
                    (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const MusterChitReportTableContent = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined || data.length === 0) return <tr><td colSpan={contentRowNames.length}>No data available</td></tr>;

    const content = (da) => contentRowNames.map((row, index) => {
        if (row === "isActive") {
            return da[row] === true ? <td key={row}>Active</td> : <td key={row}>Inactive</td>;
        }
        else if (row === "fieldName") {
            return da[row] === null ? <td key={row}>-</td> : <td key={row}>{da[row]}</td>;
        }
        else if (row === "isDefaultValueEnabled") {
            return da[row] === true ? <td key={row}>Yes</td> : <td key={row}>No</td>;
        } else if (row === "subFieldName") {
            return da[row] === undefined || da[row] === null ? <td key={row}>-</td> : <td key={row}>{da[row]}</td>;
        }
        return <td key={row}>{da[row] + " "}</td>;
    });



    return data.map((da, i) => {
        return (
            <tr key={i}
            // style={{
            //     backgroundColor: da.assignAt != '-' ? "white" : "#FF7074"
            // }}
            >
                {content(da)}
            </tr>
        );
    });

}

export const TaskDetailReportTableContent = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "progress") ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td> :
                    (row === "fieldName") ? (da[row] === null ? <td key={index}>-</td> : <td key={index}>{da[row]}</td>) :
                        (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)

            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}


export const EmployeeTaskDetailReportTableContent = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "progress") ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td> :
                    (row === "startTime") ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td> :
                        (row === "endTime") ? <td key={index} style={{ textAlign: "right" }}>{da[row]}</td> :
                            (row === "fieldName") ? (da[row] === null ? <td key={index}>-</td> : <td key={index}>{da[row]}</td>) :
                                (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const OperationEntityConfigurationTableContent = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "isApply" ? (da[row] === true ? <td key={index}>True</td> : <td key={index}>False</td>) : <td key={index}>{da[row] + " "}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit || hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : <td></td>}
            </tr>
        );
    })
}

export const HalfNameMarkReportTableContent = ({ data, contentRowNames, handleClick }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentPurchaseViewSecond = ({ data, contentRowNames, handleClick, purchaseValue }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "measuringUnit" ? (da[row] === 1 ? <td key={index}>Kg</td> : <td key={index}>Unit</td>) :
                    (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>))
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const CreateQRTagTable = ({ data, contentRowNames, handleClick, hasEdit }) => {

    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "tagNo" ? (<td key={index}>{da[row] + " "}</td>) :
                row === "numberOfUnits" ? <td key={index} style={{ textAlign: "center" }}>{da[row] + " "}</td> :
                    isNaN(da[row]) ? <td style={{ textAlign: "left" }} key={index}>{da[row] + " "}</td>
                        : <td style={{ textAlign: "left" }} key={index}>-</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {(hasEdit === undefined) ? <td onClick={() => handleClick(da)} style={{ cursor: "pointer" }}><i className="far fa-edit"></i></td> : null}
            </tr>
        );
    })
}

export const TableContentCustomerAccount = ({ data, contentRowNames, handleClick, handleClickView, hasEdit, hasView, handleClick2, hasEdit2 }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                <td key={index}>{da[row] + " "}</td>
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {/* {(hasView || hasView === undefined) ? <td onClick={() => handleClickView(da)} style={{cursor: "pointer"}}><i className="fas fa-eye"></i></td> : null} */}
                {/* {(hasEdit || hasEdit === undefined) ? <td >
                    <Button><i className="far fa-edit" onClick={() => handleClick(da)} style={{cursor: "pointer"}}></i></Button>
                   <Button> <i className="fas fa-tasks" onClick={() => handleClick2(da)} style={{cursor: "pointer"}}></i></Button></td> : null} */}
            </tr>
        );
    })
}

export const TableBLFactoryWeighReport = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (da[row] === undefined ? <td key={index} style={{ textAlign: "center" }}>-</td> :
                index > 6 ? <td key={index} style={{ textAlign: (row === "lossGain" ? "center" : "center") }}>{da[row] + " "}</td> :
                    <td key={index} style={{ textAlign: "center" }}>{da[row] + " "}</td>)
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentGreenleafRouteSummaryReport = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {

        return (
            da[row] === undefined ? <td key={index} style={{ textAlign: "right" }}>0</td> :
                row !== "collectionPointName" ?
                    <td key={index} style={{ textAlign: "right" }}>{da[row]}</td>
                    : <td key={index} style={{ textAlign: "left" }}>{da[row]}</td>

        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
            </tr>
        );
    })
}

export const TableContentForEmployeeImageReportSundry = ({ data, contentRowNames, handleClick }) => {
    if (data === undefined) return null;

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            row === "isActive" ? (
                <td key={index}>{da[row] === true ? "Active" : "Inactive"}</td>
            ) : (row === "employeeCode" || row === "fullName" || row === "taskCode" || row === "jobType") ? (
                <td key={index}>{da[row] + ""}</td>
            ) : row === "convertedEmployeeBiometricData" ? (
                <td key={index} style={{ textAlign: "center" }}>
                    <img
                        src={defaultImg}
                        width="75"
                        height="75"
                        alt="Employee"
                    />
                </td>
            ) : (
                <td key={index} style={{ textAlign: "center" }}>
                    <img
                        src={da[row]}
                        width="75"
                        height="75"
                        alt="Employee"
                    />
                </td>
            )
        );
    });
    return data.map((da, i) => (
        <tr key={i}>
            {content(da)}
        </tr>
    ));

    
};

export const TableContentView = ({ data, contentRowNames, handleView, hasEdit }) => {

    if (data === undefined) return null

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                (row === "isDefaultValueEnabled" ? (da[row] === true ? <td key={index}>Yes</td> : <td key={index}>No</td>) : <td key={index}>{da[row] + " "}</td>)
            )
        )
    })

    return data.map((da, i) => {
        return (
            <tr key={i}>
                {content(da)}
                {hasEdit ? <td onClick={() => handleView(da)} style={{ cursor: "pointer" }}><i className="fas fa-eye"></i></td> : null}
            </tr>
        );
    })
};

